module.exports = __webpack_public_path__ + "static/media/meet-miek.95afbd4c.png";